import { store } from 'src/store'
import * as actions from './index'
import { startPolling as appStartPoll } from '../../../App/actions'
export function addUserMessage(text, timestamp = Date.now()) {
  store.dispatch(actions.addUserMessage(text, timestamp))
}

export function addResponseMessage(text, timestamp = Date.now(), isLiveAgent = false) {
  store.dispatch(actions.addResponseMessage(text, timestamp, isLiveAgent))
}

export function addCarousel(carousel) {
  store.dispatch(actions.addCarousel(carousel))
}

export function renderCustomComponent(component, props, showAvatar = false) {
  store.dispatch(actions.renderCustomComponent(component, props, showAvatar))
}

export function toggleWidget() {
  store.dispatch(actions.toggleChat())
}

export function openWidget() {
  store.dispatch(actions.openChat())
}

export function resetChat() {
  store.dispatch(actions.resetChat())
}

export function closeWidget() {
  store.dispatch(actions.closeChat())
}

export function dropMessages() {
  store.dispatch(actions.dropMessages())
}

export function setQuickButtons(buttons) {
  store.dispatch(actions.setQuickButtons(buttons))
}

export function setMenu(menu) {
  store.dispatch(actions.setMenu(menu))
}

export function setToc(toc) {
  store.dispatch(actions.setToc(toc))
}
export function setInputDisabled(inputDisabled) {
  store.dispatch(actions.setInputDisabled(inputDisabled))
}
export function setBlink(blink) {
  store.dispatch(actions.setBlink(blink))
}
export function setBlinkColor(color) {
  return store.dispatch(actions.setBlinkColor(color))
}
export function setInputDropdownType(dropdownInput) {
  store.dispatch(actions.setInputDropdownType(dropdownInput))
}
export function setDropdownOptions(dropdownOptions) {
  store.dispatch(actions.setDropdownOptions(dropdownOptions))
}
export function setInputDateType(dateInput) {
  store.dispatch(actions.setInputDateType(dateInput))
}
export function setIsFetching(isFetching) {
  store.dispatch(actions.setIsFetching(isFetching))
}
export function setTheme(theme) {
  store.dispatch(actions.setTheme(theme))
}
export function setStyles(styles) {
  store.dispatch(actions.setStyles(styles))
}

export function setSenderPlacholder(str) {
  store.dispatch(actions.setSenderPlacholder(str))
}

export function startPolling() {
  store.dispatch(appStartPoll())
}

export function clearInput(clearInput) {
  store.dispatch(actions.clearInput(clearInput))
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/actions/dispatcher.js